import Img1 from "../assets/images/v2026/home/fp3-experiencia.webp"
import Img2 from "../assets/images/porqueimg2.jpg"
import Img3 from "../assets/images/porqueimg3.jpg"
import Img4 from "../assets/images/porqueimg4.jpg"
export default [
  {
    title: "EXPERIENCIA Y TRAYECTORIA",
    text:
      "20 años de crecimiento sostenido y más de 40 años de experiencia generacional.",
    image: Img1,
  },
  {
    title: "INNOVACIÓN",
    text:
      "Nuestro sistema de ensamblaje modular permite la personalización y hace sostenible la innovación de nuestros vehículos",
    image: Img2,
  },
  {
    title: "RENDIMIENTO",
    text: "Carrocerías sólidas hechas para las carreteras del Perú",
    image: Img3,
  },
  {
    title: "GARANTÍA",
    text:
      "Comprobadas y aprobadas. Contamos con certificaciones que garantizan nuestra calidad.",
    image: Img4,
  },
]
